import { render, staticRenderFns } from "./ChatMessage.vue?vue&type=template&id=534f26b2&scoped=true&"
import script from "./ChatMessage.vue?vue&type=script&lang=js&"
export * from "./ChatMessage.vue?vue&type=script&lang=js&"
import style0 from "./ChatMessage.vue?vue&type=style&index=0&id=534f26b2&prod&scoped=true&lang=scss&"
import style1 from "./ChatMessage.vue?vue&type=style&index=1&id=534f26b2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534f26b2",
  null
  
)

export default component.exports